<template>
  <div class="about">
    <div class="about__data">
      <div>PBLMed is an online problem-based learning platform. Virtual patients are presented along with results from a growing
      list of over 220 question, 130 exams, and 640 tests including x-rays, MRI, lab values, records, and sound files.
      Treat virtual patients to see how your diagnosis and treatment plans correlate with real life cases.
      <br>
      Click <strong>GET STARTED</strong> here for access to these cases. Free access is limited to results from initial patient encounters.
      Contact us at help@pblmed.com for access to subsequent encounters, progress reports, suggested learning issues and
      objectives for each case.
      </div>
      <v-btn color="primary" large @click="navRegister()" class="mt-8">Get Started</v-btn>
    </div>
  </div>
</template>

<script>
import router from '../routes'

export default {
  methods: {
    navRegister: function () {
      if (this.$route.path !== '/signin') {
        router.push('/signin')
      }
    }
  },
  created () {
    this.$store.dispatch('changeShowToolbar', false)
  }
}
</script>

<style lang="css" scoped>
  .about {
    font-family: 'Alegreya', serif;
    /* font-family: Montserrat; */
    /* padding-top: 20%;
    padding-left: 12%;
    line-height: 3rem; */
    border: 2px solid white;
    height: 100%;
    display: block;
    justify-content: center;
    background-size: cover;
    background-position: 100%;
    background-image: url('/static/login-bg.jpg');
  }
  .about__data {
    font-size: 1.8rem;
    height: 100%;
    padding-left: 10%;
    padding-right: 10%;
    /* line-height: 3rem; */
    margin-top: 10%;
    /* display: flex; */
  }
  .aboutIcon {
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue